import { z } from 'zod';

// Mirror of `backend/src/auth/password-policy.ts` — keep both in lockstep.
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_REQUIRED_CATEGORIES = 3;

export const PASSWORD_FAILURE_MESSAGE = `Password must be at least ${PASSWORD_MIN_LENGTH.toString()} characters and include at least ${PASSWORD_REQUIRED_CATEGORIES.toString()} of: lowercase, uppercase, digit, symbol.`;

export function passwordCategoryCount(value: string): number {
  let count = 0;
  if (/[a-z]/.test(value)) count += 1;
  if (/[A-Z]/.test(value)) count += 1;
  if (/\d/.test(value)) count += 1;
  if (/[^A-Za-z0-9\s]/.test(value)) count += 1;
  return count;
}

export function isValidPassword(value: string): boolean {
  return (
    value.length >= PASSWORD_MIN_LENGTH &&
    passwordCategoryCount(value) >= PASSWORD_REQUIRED_CATEGORIES
  );
}

export const passwordSchema = z
  .string()
  .refine(isValidPassword, { message: PASSWORD_FAILURE_MESSAGE });
